// This file is forked from office-bohemia-ux's StylingConstants file and it should be kept in sync

import {
  ThemeColorPropertyNames,
  ThemeColorPalette,
  ThemeFontsCssPropertyName,
  ThemeColorPaletteShared
} from '@fluidx/component-ux';
import { HighContrastSelector, IButtonStyles, IFontWeight } from '@fluentui/react';

export const menuStylingConstants = {
  menuBackgroundColor: `var(${ThemeColorPropertyNames.MenuBackground}, ${ThemeColorPalette.Neutral.white})`,
  menuBorderColor: `var(${ThemeColorPropertyNames.MenuHeader}, ${ThemeColorPalette.Neutral.neutralLight})`,
  dividerBackgroundColor: `var(${ThemeColorPropertyNames.MenuDivider}, ${ThemeColorPalette.Neutral.neutralQuaternaryAlt})`
};

export const buttonStylingConstants = {
  buttonFontFamily: `var(${ThemeFontsCssPropertyName.FontFamilyMenu}, Segoe UI, sans-serif)`,
  buttonFontSize: `var(${ThemeFontsCssPropertyName.FontSizeMenu}, 14px)`,
  buttonFontWeight: `var(${ThemeFontsCssPropertyName.FontWeightMenu}, 400)` as IFontWeight,
  buttonColor: `var(${ThemeColorPropertyNames.MenuItemText}, ${ThemeColorPalette.Neutral.neutralPrimary})`,
  buttonDisabledColor: `var(${ThemeColorPropertyNames.DisabledBodyText}, ${ThemeColorPalette.Neutral.neutralTertiary})`,
  buttonHoverColor: `var(${ThemeColorPropertyNames.MenuItemTextHovered}, ${ThemeColorPalette.Neutral.neutralDark})`,
  buttonHoverFocusBackgroundColor: `var(${ThemeColorPropertyNames.MenuItemBackgroundHovered}, ${ThemeColorPalette.Neutral.neutralLighter})`,
  buttonPressedBackgroundColor: `var(${ThemeColorPropertyNames.MenuItemBackgroundPressed}, ${ThemeColorPalette.Neutral.neutralLight})`,
  outlineColor: ThemeColorPalette.Neutral.neutralSecondaryAlt,
  outlineFocusedColor: `var(${ThemeColorPropertyNames.FocusBorder}, ${ThemeColorPalette.Neutral.black})`
};

export const scrollbarStylingConstants = {
  scrollbarBackgroundColor: `var(${ThemeColorPropertyNames.BodyBackgroundChecked}, ${ThemeColorPaletteShared.Gray100})`,
  scrollbarPressedBackgroundColor: `var(${ThemeColorPropertyNames.BodyBackgroundChecked}, ${ThemeColorPaletteShared.Gray6})`
};

const iconButtonClassNames = {
  root: 'icon-button-root',
  icon: 'icon-button-child'
};

export const iconButtonStyles: IButtonStyles = {
  root: [
    iconButtonClassNames.root,
    {
      color: buttonStylingConstants.buttonColor,
      backgroundColor: menuStylingConstants.menuBackgroundColor,
      margin: '4px',
      outline: '1px solid',
      outlineOffset: '-2px',
      outlineColor: 'transparent',
      selectors: {
        [HighContrastSelector]: {
          color: 'windowText',
          backgroundColor: 'window',
          MsHighContrastAdjust: 'none',
          forcedColorAdjust: 'none'
        }
      }
    }
  ],
  rootChecked: [
    iconButtonClassNames.root,
    {
      color: buttonStylingConstants.buttonColor,
      backgroundColor: buttonStylingConstants.buttonPressedBackgroundColor,
      margin: '4px',
      outline: '1px solid',
      outlineOffset: '-2px',
      outlineColor: buttonStylingConstants.outlineColor,
      selectors: {
        [HighContrastSelector]: {
          color: 'highlightText',
          backgroundColor: 'highlight',
          MsHighContrastAdjust: 'none',
          forcedColorAdjust: 'none'
        }
      }
    }
  ],
  rootDisabled: [
    iconButtonClassNames.root,
    {
      color: buttonStylingConstants.buttonDisabledColor,
      backgroundColor: menuStylingConstants.menuBackgroundColor,
      margin: '4px',
      outline: '1px solid',
      outlineOffset: '-2px',
      outlineColor: 'transparent',
      selectors: {
        [HighContrastSelector]: {
          color: 'grayText',
          backgroundColor: 'highlight',
          MsHighContrastAdjust: 'none',
          forcedColorAdjust: 'none'
        }
      }
    }
  ],
  iconDisabled: [
    {
      color: buttonStylingConstants.buttonDisabledColor,
      selectors: {
        [HighContrastSelector]: {
          color: 'grayText'
        }
      }
    }
  ],
  rootHovered: {
    color: buttonStylingConstants.buttonColor,
    backgroundColor: buttonStylingConstants.buttonHoverFocusBackgroundColor,
    selectors: {
      [HighContrastSelector]: {
        backgroundColor: 'highlight',
        color: 'highlightText',
        MsHighContrastAdjust: 'none',
        forcedColorAdjust: 'none'
      }
    }
  },
  rootCheckedHovered: {
    color: buttonStylingConstants.buttonColor,
    backgroundColor: buttonStylingConstants.buttonHoverFocusBackgroundColor,
    selectors: {
      [HighContrastSelector]: {
        backgroundColor: 'highlight',
        color: 'highlightText',
        MsHighContrastAdjust: 'none',
        forcedColorAdjust: 'none'
      }
    }
  },
  rootPressed: {
    backgroundColor: buttonStylingConstants.buttonPressedBackgroundColor,
    color: buttonStylingConstants.buttonColor,
    selectors: {
      [HighContrastSelector]: {
        backgroundColor: 'highlight',
        color: 'highlightText',
        MsHighContrastAdjust: 'none',
        forcedColorAdjust: 'none'
      }
    }
  },
  rootFocused: {
    color: buttonStylingConstants.buttonColor,
    outline: `1px solid ${ThemeColorPalette.Neutral.black}`,
    outlineOffset: '-2px',
    selectors: {
      [HighContrastSelector]: {
        backgroundColor: 'highlight',
        color: 'highlightText',
        MsHighContrastAdjust: 'none',
        forcedColorAdjust: 'none'
      }
    }
  }
};
